const ResponseStatusEnum = {
  SUCCESS: "success",
  ERROR: "error",
  WARN: "warn",
  INFO: "info",
};
export default ResponseStatusEnum;
